<template>
  <div class="mobile-button-container">
    <v-flex class="mb-16 mobile-button hide">
      <main-button
        depressed
        :text="adminText('workflowsAll.create_email_cf6523e', 'Create email')"
        @click="
          goTo(
            isRegularOrganization()
              ? routes.organizer.createEmail
              : routes.sportOrganizer.createEmailSport,
            { eventId: eventId },
          )
        "
      />
    </v-flex>
    <v-layout column>
      <div class="page-header">
        <v-flex class="title-screen" xs12>
          <span>{{ adminText('workflowsAll.e_mails_to_attendees_475b4df', 'E-mails to attendees') }}</span>
        </v-flex>
        <v-flex class="mb-16 desktop-button">
          <main-button
            depressed
            :disabled="!user"
            @click="handleCreateEmailClick"
          >
            <div class="plus-sign">+</div>
            {{ adminText('workflowsAll.create_email_cf6523e', 'Create email') }}
          </main-button>
        </v-flex>
      </div>
      <v-data-table
        v-model="tableValue"
        :headers="workflowUi(headers)"
        :items="workflowUi(items)"
        :rows-per-page-items="rowsPerPageItems"
        :rows-per-page-text="workflowLabel(isDesktop ? adminText('workflowsAll.rows_per_page_79df325', 'Rows per page:') : '')"
        item-key="id"
        disable-initial-sort
        style="border: 1px solid #f5f5f5f !important"
        class="table-container"
      >
        <template slot="items" slot-scope="props">
          <tr
            style="
              position: relative;
              z-index: 4;
              cursor: pointer;
              border: 1px solid #f5f5f5 !important;
            "
            @click="openEmailDetails(props.item.id, props.item.type)"
          >
            <td>
              <v-flex justify-center align-center>
                <v-switch
                  v-if="props.item.type == 'Automated'"
                  :input-value="props.item.status"
                  color="#ff4c00"
                  style="position: relative; z-index: 1"
                  @click.prevent="e => changeButton(e, props.item)"
                />
                <span v-else class="sent-style">{{ adminText('workflowsAll.sent_35f49dc', 'Sent') }}</span>
              </v-flex>
            </td>
            <td>
              <div
                :class="props.item.type == 'Custom' ? 'custom-type-style' : 'automated-type-style'"
              >
                <span>{{ workflowLabel(props.item.type) }}</span>
              </div>
            </td>
            <td>
              <span v-if="props.item.type == 'Automated'">{{ workflowLabel(props.item.sent) }}</span>
              <span v-else>{{ workflowDate(props.item.updatedAt, 'LL H:mm') }}</span>
            </td>
            <td>{{ workflowLabel(props.item.subject) }}</td>
            <td>{{ workflowLabel(props.item.emailRecipient.recipientType) }}</td>
            <td>
              <v-icon
                v-show="props.item.type == 'Custom'"
                :key="props.item.id"
                small
                @click.prevent="e => startDelete(props.item, e)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template slot="no-data"> {{ adminText('workflowsAll.create_your_first_referral_3d73968', 'Create your first referral') }} </template>
      </v-data-table>
    </v-layout>
    <delete-dialog
      :content="workflowLabel((adminText('workflowsAll.are_you_sure_you_want_to_delete_selected_emai_23aa06b', 'Are you sure you want to delete selected email? This operation cannot be undone.')))"
      :on-delete="deleteEmail"
      :show.sync="showDeleteDialog"
      :title="adminText('workflowsAll.delete_email_12b2a4e', 'Delete email')"
    />
    <demo-modal
      v-if="demoModal"
      :user="user"
      @close="demoModal = false"
    />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import DeleteDialog from './../shared/dialogs/delete-dialog.vue'
import { formatDate } from '@/utils'
import {
  GET_EMAILS,
  DELETE_EMAIL,
  UPDATE_EMAIL,
  CHECK_AUTOMATED_EMAILS,
} from '@/graphql/email.graphql'
import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import DemoModal from '@/components/organizations/DemoModal.vue'
export default {
  mixins: [WorkflowDisplay],
  name: 'emails-list-container',
  components: {
    DeleteDialog,
    DemoModal,
  },
  props: {
    eventId: String,
  },
  data() {
    return {
      user: null,
      demoModal: false,
      attendeeFields: [],
      eventAttendeeFields: {},
      showDeleteDialog: false,
      tableValue: [],
      deleteId: undefined,
      isDesktop: false,
      headers: [
        {
          text: 'workflowsAll.status_bae7d5b',
          align: 'left',
          sortable: true,
          value: 'status',
        },
        {
          text: 'workflowsAll.type_3deb745',
          align: 'left',
          sortable: true,
          value: 'type',
        },
        {
          text: 'workflowsAll.sent_35f49dc',
          align: 'left',
          sortable: true,
          value: 'sent',
        },
        {
          text: 'workflowsAll.subject_8d183db',
          align: 'left',
          sortable: true,
          value: 'subject',
        },
        {
          text: 'workflowsAll.recipients_78cbf8e',
          align: 'left',
          sortable: true,
          value: 'recipients',
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: null,
        },
      ],
      items: [],
      rowsPerPageItems: [5, 10, 25, 100],
    }
  },
  apollo: {
    me: {
      query: GET_LOGGED_USER,
      async result({ data, loading }) {
        if (!loading && data) {
          const { me: user } = data
          this.user = user
          if (this.organizationCreated && !this.user.isVerifiedByCoreEvent) {
            this.demoModal = true
          }
        }
      },
    },
    getEmails: {
      query: GET_EMAILS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const { getEmails } = data
          this.$apollo.mutate({
            mutation: CHECK_AUTOMATED_EMAILS,
            variables: {
              eventId: this.eventId,
            },
            refetchQueries: ['GetEmails'],
          })
          this.items = getEmails
            .map(email => {
              return {
                ...email,
                updatedAt: email.updatedAt,
              }
            })
            .sort((a, b) => {
              return a.id - b.id
            })
        }
      },
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.isDesktop = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    handleCreateEmailClick() {
      if (!this.user) return

      if (this.user.isVerifiedByCoreEvent) {
        this.goTo(
          this.isRegularOrganization()
            ? this.routes.organizer.createEmail
            : this.routes.sportOrganizer.createEmailSport,
          { eventId: this.eventId },
        )
      } else {
        this.demoModal = true
      }
    },
    openEmailDetails(id, type) {
      if (type === 'Automated') {
        this.goTo(
          this.isRegularOrganization()
            ? this.routes.organizer.updateEmail
            : this.routes.sportOrganizer.updateEmailSport,
          { eventId: this.eventId, emailId: id },
        )
      } else {
        this.goTo(
          this.isRegularOrganization()
            ? this.routes.organizer.emailDetails
            : this.routes.sportOrganizer.emailDetailsSport,
          { eventId: this.eventId, emailId: id },
        )
      }
    },
    async changeButton(ev, item) {
      ev.stopPropagation()
      await this.$apollo.mutate({
        mutation: UPDATE_EMAIL,
        variables: {
          emailId: item.id,
          email: {
            status: !item.status,
          },
        },
        refetchQueries: ['GetEmails'],
      })
    },
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.isDesktop = true
      } else {
        this.isDesktop = false
      }
    },
    startDelete(email, ev) {
      ev.stopPropagation()
      this.showDeleteDialog = true
      this.deleteId = email.id
    },
    async deleteEmail() {
      await this.$apollo.mutate({
        mutation: DELETE_EMAIL,
        variables: { emailId: this.deleteId },
        refetchQueries: ['GetEmails'],
      })
      this.showDeleteDialog = false
      this.deleteId = undefined
    },
    isRegularOrganization() {
      return this.$route.path.includes('/organizations/')
    },
  },
}
</script>

<style scoped>
.screen-description {
  max-width: 680px;
  margin-bottom: 28px;
}
.automated-type-style {
  width: 81px;
  height: 24px;
  border-radius: 4px;
  background-color: rgba(2, 119, 189, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #0277bd;
}
.custom-type-style {
  width: 61px;
  height: 24px;
  border-radius: 4px;
  background-color: rgba(51, 51, 51, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #333333;
}
.sent-style {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333333;
}
>>> .v-input--selection-controls {
  margin-bottom: 0px !important;
  padding-top: 0px !important;
}
>>> .v-input__slot {
  margin-bottom: 0px !important;
}
>>> .v-messages {
  min-height: 0px !important;
}
.page-header {
  display: flex;
  align-items: flex-end;
}
.plus-sign {
  font-size: 2.25rem;
  font-weight: 100;
  margin-right: 0.625rem;
}
.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
}
</style>
